import React from 'react'
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import axios from 'axios'
import { connect } from 'react-redux'
import { fade, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Chip from '@material-ui/core/Chip';
import AdbIcon from '@material-ui/icons/Adb';
import { Button, CircularProgress }  from '@material-ui/core';
import Grid from '@material-ui/core/Grid'
// import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import AddIcon from '@material-ui/icons/AddCircle';
// import FilterListIcon from '@material-ui/icons/FilterList';
import moment from 'moment'
import { Link } from 'react-router-dom'
// import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { socket } from '../SocketIo/Socket'
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
// import ProjectDetailsModal from './ProjectDetailsModal';
import UploadDetailsModal from './UploadDetailsModal'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete'
import DeleteComponent from '../Common/DeleteComponent'
import ProtectedButton from '../../actions/protectedButtons'

function desc(a, b, orderBy, isDate) {
  // console.log('desc: ', a)
  // console.log('desc b: ', b)
  if (isDate) {
    if (b[orderBy] < a[orderBy] || b[orderBy] == null) {
      // console.log('B is < A')
      return -1;
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] == null) {
      // console.log('B is > A')
      return 1;
    }
    // console.log('B is ? A')
    // console.log('A: ', a[orderBy])
    // console.log('B: ', b[orderBy])
    return 0;
  } else {
    if (b[orderBy] < a[orderBy] || b[orderBy] == null) {
      return -1;
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] == null) {
      return 1;
    }
    return 0;
  }
}

function stableSort(array, cmp) {
  // console.log('Stable sort: ', array.length)
  // console.log('CMP: ', cmp)
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  // console.log('Matches: ', stabilizedThis.length)
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  if (orderBy==='lastUpdated') {
    // console.log('Last Updated')
    return order === 'desc' ? (a, b) => desc(a, b, orderBy, true) : (a, b) => -desc(a, b, orderBy, true);
  } else {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
  }
  
}

function currencyFormat(num) {
  if (!num) num = 0
  return '$' + parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const headCells = [
  { id: 'name', numeric: false, disablePadding: false, label: 'File Name' },
  { id: 'type', numeric: false, disablePadding: false, label: 'File Type' },
  { id: 'category', numeric: false, disablePadding: false, label: 'File Category' },
  { id: 'size', numeric: false, disablePadding: false, label: 'File Size' },
  { id: 'notes', numeric: false, disablePadding: false, label: 'File Notes' },
  { id: 'created_at', numeric: false, disablePadding: false, label: 'Created' },
  { id: 'preview', numeric: false, disablePadding: false, label: 'Preview' },
  { id: 'actions', numeric: false, disablePadding: false, label: 'Actions' },
];

function EnhancedTableHead(props) {
  // console.log('Upload List ', props)
  
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    // console.log('Sort Property: ', property)
    // console.log('sort event; ', event)
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all leads' }}
          />
        </TableCell> */}
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={order}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '95%',
    margin: 10
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fakeLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'blue'
  },
  rowPad: {
    height: '40px !important',
    // padding: 'px'
  }
}));

function EnhancedTable(props) {
// console.log('CUSTOMER UPLOADS PROPS ', props)
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('-created');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [searchValue, setsearchValue] = React.useState('');
  const [searchMatches, setsearchMatches] = React.useState(0);
  const [open, setOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [rows, setRows] = React.useState([])
  const [filteredRows, setFilteredRows] = React.useState([])
  const [activeUpload, setActiveUpload] = React.useState({})
  const [state, setState] = React.useState({
    searchMatches: 0,
    project: {}
  })
  const [showUploadDetails, setShowUploadDetails] = React.useState(false)
  
  React.useEffect(() => {
    // console.log('UPLOAD LIST UE:::', props.uploads)
    setRows(props.uploads)
    setFilteredRows(props.uploads)
  }, [props])

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    // console.log('Set order by property: ' + property + ' in ' + isDesc + ' order')
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n._id);
      // console.log(newSelecteds)
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // const handleClick = (event, name) => {
  //   const selectedIndex = selected.indexOf(name);
  //   // console.log('handle click ', name)
  //   // console.log('Index: ', selectedIndex)
  //   let newSelected = [];

  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(selected, name);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(selected.slice(1));
  //   } else if (selectedIndex === selected.length - 1) {
  //     newSelected = newSelected.concat(selected.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(
  //       selected.slice(0, selectedIndex),
  //       selected.slice(selectedIndex + 1),
  //     );
  //   }

  //   setSelected(newSelected);
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const storeSearchMatches = (d) => {
    // console.log('Search matches: ', d)
    // setState({...state, searchMatches: d.length})
  }
  // const handleChangeDense = event => {
  //   setDense(event.target.checked);
  // };

  const isSelected = name => selected.indexOf(name) !== -1;

  const emptyRows = 0// rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const filterOut = (r, searchText) => {
    // console.log('FIlter out: %s - %s', r, searchText)
    let string = searchText
    let newArr = []
    r.filter(o => {
      // console.log('Object:  ', o)
      Object.keys(o).some(k => {
        // console.log(o[k])
        if(o[k]) {
          // console.log('OK: ', o[k])
          let str = o[k].toString().toLowerCase() 
          // console.log(str)
          if (str.includes(string.toLowerCase())) {
            // console.log('Mathc')
            return newArr.push(o)
          } else {
            return null
          }
        } else {
          return null
        }
      })
      // return newArr
    })
    // return newArr
    // console.log('Lenght: ', newArr.length)
    // console.log(newArr)
    // storeSearchMatches(newArr)
    // setsearchMatches(newArr.length)
    // return newArr
    setFilteredRows(newArr)
    // let newArr = r.filter(i => {
    //   if (i.includes('test')) return i
    // })
    // return newArr
    // return r.filter((obj)=>{
    //   return Object.keys(obj).reduce((acc, curr)=>{
    //         return acc || obj[curr] ? obj[curr].toString().toLowerCase().includes(string) : obj[curr];
    //   }, false);
    // })
  }
  const handleChange = (name) => (event) => {
    // console.log('Searching: ', event.target.value)
    setsearchValue(event.target.value)
    if (event.target.value === '') {
      setFilteredRows(rows)
    } else {
      filterOut(rows, event.target.value)
    }
    setPage(0)
  }

  const openUploadDetails = (upload) => {
    setState({...state, upload: upload})
    setActiveUpload(upload)
    setShowUploadDetails(true)
  }

  const handleSaveUpdate = (upload) => {
  // console.log('Save this: ', upload)
    let currentRows = rows
    let index = currentRows.findIndex(item => (item._id === upload._id))
    if (index > -1) {
      currentRows[index] = upload
      setRows(currentRows)
      filterOut(currentRows, searchValue)
    }
    setShowUploadDetails(false)
    setActiveUpload({})
    setState({...state, upload: {}})
  }

  const handleDownload = (row) => {
    // console.log('download', row)
    let encoded = row.url // encodeURI(row.url)
    // console.log(encoded)
    props.notification({
      type: 'success',
      message: 'Preparing Your Download Now',
      title: 'Download Request Received'
    })
    let finalURL = encoded
    if (encoded.includes('https://')) {

    } else {
      finalURL = 'https://' + encoded
    }
    // console.log('Open: ', finalURL)
    window.open(finalURL, '_blank')
  }

  const handleDelete = (row) => {
    let currentRows = rows
    let index = rows.findIndex(item => (item._id === row._id))
    if (index > -1) {
      currentRows.splice(index, 1)
    }
    setRows(currentRows)
    filterOut(currentRows, searchValue)
  }
  const handleExportVendorInvoices = () => {
    let vendorInvoices = props.uploads.filter((item, index) => (item.documentType === 'Vendor Invoice'))
  // console.log('Vendor invoices to export:', vendorInvoices)
    let obj = {
      vendorInvoices: vendorInvoices,
      client: props.client
    }
    axios({
      method: 'post',
      url:  `${props.url}/api/company/exportToCSV`,
      data: obj,
      // validateStatus: (status) => {
      //   // console.log('Validate status: ', status)
      //   if (status && status === 500) {
  
      //   }
      // },
    }).then(response => {
      // console.log('Export response: ', response.data)
      let newBlob = new Blob([response.data], {type: "text/csv"})
      // console.log(newBlob)
      const data = window.URL.createObjectURL(newBlob);
      // console.log(data)
      var link = document.createElement('a');
      link.href = data;
      let fileName = 'CSV_Export'.replace(/[^a-z0-9]/gi, '_').toLowerCase()
      link.download=`${fileName}.csv`;
      link.click();
    })
  }
  
  return (
    <div className={classes.root}>
      <UploadDetailsModal open={showUploadDetails} upload={activeUpload} projects={props.projects} closeModal={e => setShowUploadDetails(false)} updateUpload={handleSaveUpdate} />
      {/* <ProjectDetailsModal open={showProjectDetailsModal} project={state.project} closeModal={e=> setShowProjectDetailsModal(false) } /> */}
     <Paper className={classes.paper}>
        Total Files: {rows.length}

        <Grid container style={{padding: '10px'}}>
         
          <Grid item lg={6} xs={12}>

            <div className={classes.search}>
                <div >
                  <SearchIcon /> Search { searchValue ? filteredRows.length > 1 ? `(${filteredRows.length} Matches)` : `(${filteredRows.length} Match)` : ''}
                </div>
                <input name="search" value={ searchValue } onChange={ handleChange('search') } type="text"></input>
              </div>
          </Grid>
          <Grid item lg={6}>
            <Tooltip title="Export to CSV" >
              <IconButton edge='end' onClick={handleExportVendorInvoices} alt="Export Vendor Invoices" aria-label="Export Vendor Invoices">
                <ImportExportIcon />
              </IconButton>
            </Tooltip>
          </Grid>

        </Grid>
        <div className={classes.tableWrapper} style={{margin: '10px'}}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
            options={{
              rowStyle: {height: 55}
            }}
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody >
              { stableSort(filteredRows, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  // console.log('Row map: ', row)
                  // console.log('Total rows; ', rows)
                  const isItemSelected = isSelected(row._id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  let url = ''
                  if (row && row.photos && row.photos.length) url = row.photos[0]['url']
                  // setsearchMatches(rows.length)
                  let theURL = row.url
                  if (!theURL.includes('https')) theURL = 'https://' + row.url
                  // console.log('URL:', theURL)
                  // let thumIoURL = 'https://image.thum.io/get/' + theURL
                  // console.log('Thumio URL:', thumIoURL)
                    return (
                    
                      <TableRow
                        hover
                        // onClick={event => handleClick(event, row._id)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row._id}
                        className={classes.rowPad}
                        selected={isItemSelected}
                      >
                       <TableCell component="th" id={labelId} scope="row" padding="none">
                        <span className={classes.fakeLink} onClick={() => openUploadDetails(row)}>{row.name || 'Un-Named Upload'}</span>
                        {/* {row.name} */}
                      </TableCell>

                        <TableCell align="left">
                          
                          { row.type }
                        </TableCell>
                        <TableCell align="left">
                          
                          { row.category ? row.category : row.documentType ? row.documentType : 'Unknown'}
                        </TableCell>
                        <TableCell align="left">
                        { row.size}
                        </TableCell>
                        <TableCell>
                          {row.notes}
                        </TableCell>
                        <TableCell align="left"> {moment(row.created_at).format('MM/DD/YYYY hh:mm a')} </TableCell>
                        <TableCell align="left">
                        {/* {
                          (row && row.type && row.type.toLowerCase().includes('pdf')) ? (
                            <iframe width="100%" height="300px" src={`https://docs.google.com/gview?url=${theURL}&embedded=true`}></iframe>
                          ) : null
                        } */}
                        {
                          (row && row.type && row.type.toLowerCase().includes('image')) ?  <img src={theURL} style={{maxWidth: 80, maxHeight: 100}} /> : null
                        }
                        {/* {
                          (row && row.type && (row.type.toLowerCase().includes('officedocument'))) ? <iframe width="100%" height="300px" src={`https://docs.google.com/gview?url=${theURL}&embedded=true`}></iframe> : null
                        } */}
                        {/* {
                          (row && row.type && row.type.toLowerCase().includes('pdf')) ? (
                            <img src={thumIoURL} style={{maxWidth: 80, maxHeight: 100}} />
                          ) : null
                        } */}
                        </TableCell>
                        <TableCell align="right">
                          <Tooltip title="Download File" >
                            <IconButton
                              variant="contained"
                              edge="start"
                              size="small"
                              color="primary"
                              onClick={e => handleDownload(row)}
                              >
                                <CloudDownloadIcon />
                              </IconButton>
                          </Tooltip>
                          
                             <DeleteComponent
                                type="Uploads"
                                item={row}
                                title="Delete Upload?"
                                verificationText={`Are you sure you wish to Delete this upload?`}
                                confirmationOfIntentText="This action is irreversible, this item will be gone forever!"
                                confirmationButton="DELETE"
                                denyText="NO"
                                ifApproved={e => handleDelete(row)}
                                deleteFunction={'upload'}
                              />
                           
                           
                        </TableCell>
                      </TableRow>
                    );
 
                })
              }
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
          { loading ?<CircularProgress style={{color: '#fff'}} size={ 16 } /> : ''}
                    
        </div>
        <TablePagination
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          // onChangePage={handleChangePage}
          // onPageChange={handleChangePage}
          // onChangeRowsPerPage={handleChangeRowsPerPage}
          // onRowsPerPageChange={handleChangeRowsPerPage}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    authenticated: state.authenticated,
    notification: state.notification,
    url: state.url,
    perms: state.perms
  }
}

export default connect(mapStateToProps)(EnhancedTable)

